var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarSquares(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.155,
    height: 36,
    viewBox: "0 0 35.155 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-squares-1843193",
    transform: "translate(-89.5 -77.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M106.575,94.534H90V78h16.534V94.534Zm-15.569-.966h14.6v-14.6h-14.6Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M372.934,369.375H356.4V352.8h16.534Zm-15.569-1.006h14.6V353.806h-14.6Z",
    transform: "translate(-257.469 -265.587)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M632.175,94.534H615.6V78h16.535V94.534Zm-15.569-.966h14.563v-14.6H616.606Z",
    transform: "translate(-507.979)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M106.575,645.334H90V628.8h16.534v16.534Zm-15.569-.966h14.6v-14.6h-14.6Z",
    transform: "translate(0 -532.334)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M632.175,645.334H615.6V628.8h16.535v16.534Zm-15.569-.966h14.563v-14.6H616.606Z",
    transform: "translate(-507.979 -532.334)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarSquares);
export default __webpack_public_path__ + "static/media/sidebar-squares.d63bc5e2c5c665802d715dc321d4b75e.svg";
export { ForwardRef as ReactComponent };